module.exports = __webpack_public_path__ + "static/img/product_13.483b975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_13.jpg
// module id = iA92
// module chunks = 2